<!--Modal-->

<div class="col-md-12">
    <div class="container-btn-new">

      <button class="btn btn-primary" routerLink="/customerform">
    <i class="fa fa-user"></i>&nbsp; New Customer
  </button>

    </div>   <br>



    <mat-form-field>
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. ium">
    </mat-form-field>



    <div class="mat-elevation-z8">

        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">


            <!-- Position Column -->
            <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Company Name </th>
                <td mat-cell *matCellDef="let element"> {{element.companyname}} </td>
            </ng-container>



            <!-- Name Column -->
            <ng-container matColumnDef="firstname">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Firstname </th>
                <td mat-cell *matCellDef="let element"> {{element.firstnamecontact}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="lastname">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Lastname </th>
                <td mat-cell *matCellDef="let element"> {{element.lastnamecontact}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                <td mat-cell *matCellDef="let element"> {{element.email}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Address </th>
                <td mat-cell *matCellDef="let element"> {{element.address}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <!--
            <ng-container matColumnDef="location">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Location </th>
                <td mat-cell *matCellDef="let element">



                    <button class="btn btn-success">  <i class="fa fa-location-arrow"></i></button>
                </td>
            </ng-container>
            -->

            <!-- Symbol Column -->
            <ng-container matColumnDef="houropen">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Hour Open </th>
                <td mat-cell *matCellDef="let element"> {{element.houropen}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="hourclose">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Hour Close </th>
                <td mat-cell *matCellDef="let element"> {{element.hourclose}} </td>
            </ng-container>


               <!-- Symbol Column -->
               <ng-container matColumnDef="identification">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Id </th>
                <td mat-cell *matCellDef="let element"> {{element.identification}} </td>
            </ng-container>



            <!-- Symbol Column -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                <td mat-cell *matCellDef="let element">

                  <span class="badge badge-pill badge-primary pilas" [ngStyle]="{'background-color':  getColorStatus(element.status)  }"> {{  statusCustomer(element.status) }}</span>

                </td>
            </ng-container>


            <!-- Symbol Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
                <th mat-header-cell *matHeaderCellDef> Symbol </th>
                <td mat-cell *matCellDef="let element">

                    <button class="btn btn-success" [disabled]="element.demo" [routerLink]="['/editcustomer', element.id]"> <i class="fa fa-edit"></i></button>
                    <button class="btn btn-danger"  [disabled]="element.demo" (click)="deleteCustomer(element)" style="margin-left:5px"> <i class="fa fa-remove"></i></button>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
    </div>
</div>
